import React, { useState, useEffect, useContext } from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";

import MButton from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { NoAccessScreen } from "../../Component";
import { recordTypes } from "../../API/config";
import AddressTable from "./Components/AddressTable";
import CreateAddress from "./Components/CreateAddress";
import ViewAddress from "./Components/ViewAddress";
import { removeEntityContact } from "../../API/Entity";

import ModalDialogContext from "../../Context/ModalDialog/ModalDialogContext";
import styles from "./styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(styles);

const EndityAddresses = (props) => {
  const { entity, onContactUpdate, hasRecordPermission } = props;
  const { addresses = [], id } = entity || {};

  const classes = useStyles();

  const [isLoaded, setLoaded] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [currentAddress, setCurrentAddress] = useState();
  const [isNewContact, setNewContact] = useState(false);
  const [isEditContact, setIsEditContact] = useState(false);
  const [isViewContact, setIsViewContact] = useState(false);

  const [canViewAddresses, setCanViewAddresses] = useState();
  const [canAddAddress, setCanAddAddress] = useState();
  const [canUpdateAddress, setCanUpdateAddress] = useState();
  const [canRemoveAddress, setCanRemoveAddress] = useState();

  const { showMessage, showErrorMessage, showConfirmation } = useContext(
    ModalDialogContext
  );
  const { t } = useTranslation();

  useEffect(() => {
    const setPermissions = async () => {
      const { permissions = {} } = entity;
      const canUpdateRecord = hasRecordPermission(
        permissions,
        recordTypes.record.actions.update.name
      );

      const canViewAddresses = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewAddresses.name
      );
      setCanViewAddresses(canViewAddresses);
      if (canUpdateRecord) {
        const canAddAddress = hasRecordPermission(
          permissions,
          recordTypes.record.actions.addAddress.name
        );
        setCanAddAddress(canAddAddress);
        const canUpdateAddress = hasRecordPermission(
          permissions,
          recordTypes.record.actions.updateAddress.name
        );
        setCanUpdateAddress(canUpdateAddress);
        const canRemoveAddress = hasRecordPermission(
          permissions,
          recordTypes.record.actions.removeAddress.name
        );
        setCanRemoveAddress(canRemoveAddress);
      }
      setLoaded(true);
    };
    setPermissions();
  }, []);

  if (isLoaded && !canViewAddresses) {
    return <NoAccessScreen />;
  }

  const openNewAddressDialog = async () => {
    setCurrentAddress();
    setNewContact(true);
    setIsDialogOpen(true);
  };

  const handleClose = (status) => {
    setIsDialogOpen(false);
    setIsEditContact(false);
    setIsViewContact(false);
    setNewContact(false);
    if (status !== "cancel") {
      onContactUpdate();
    }
  };

  const viewAddress = async (addressData) => {
    setCurrentAddress(addressData);
    const { source } = addressData;
    if (source === "MDM" || !canUpdateAddress) {
      setIsViewContact(true);
    } else {
      setIsEditContact(true);
      setIsDialogOpen(true);
    }
  };

  const onDelete = async (addressData) => {
    showConfirmation({
      message: t("messages.record.addresses.deleteContact"),
      onPressYes: async (event) => {
        try {
          const result = await removeEntityContact(addressData.id, id);
          const { message } = result;
          showMessage({ message });
        } catch (error) {
          showErrorMessage({ error });
        }
        onContactUpdate();
      },
    });
  };

  return (
    <>
      <div className={classes.documentsBarContainer}>
        <Grid container direction="row" spacing={1}>
          <Grid item xs={6} container justify="flex-start" alignItems="center">
            <Typography component="span" className={classes.documentsBarTitle}>
              {t("labels.record.addresses.contactInformation")}
            </Typography>
          </Grid>
          <Grid item xs={6} container justify="flex-end" alignItems="center">
            {canAddAddress && (
              <MButton
                color="primary"
                variant="contained"
                label={t("labels.common.add")}
                style={{ height: 30 }}
                onClick={openNewAddressDialog}
              >
                <AddIcon />
              </MButton>
            )}
          </Grid>
        </Grid>
      </div>
      <div className={classes.documentsTableContainer}>
        <AddressTable
          data={addresses}
          onRowViewClick={viewAddress}
          canUpdateAddress={canUpdateAddress}
          canRemoveAddress={canRemoveAddress}
          onDelete={onDelete}
        />
      </div>
      {isDialogOpen && (
        <CreateAddress
          open={isDialogOpen}
          onclose={handleClose}
          newContact={isNewContact}
          editContact={isEditContact}
          address={currentAddress}
          entity={entity}
        />
      )}
      {isViewContact && (
        <ViewAddress
          open={isViewContact}
          onclose={handleClose}
          address={currentAddress}
          entity={entity}
        />
      )}
    </>
  );
};

export default EndityAddresses;
